import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../config/authaxios";

import Chip from "@material-ui/core/Chip";
import { useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeProvider";

import { TextField, Typography } from "@mui/material";

function Edit() {
  const search = useLocation().search;
  const navigate = useNavigate();
  const couponId = new URLSearchParams(search).get("couponId");

  const [coupons, setCoupons] = useState({});
  const [priceArray, setPriceArray] = useState([]);
  const [priceInput, setPriceInput] = useState(null);
  const [pointArray, setPointArray] = useState([]);
  const [pointInput, setPointInput] = useState(null);
  const [detailColorArray, setDetailColorArray] = useState(["#000","#000","#000"]);
  const [detailColorInput, setDetiailColorInput] = useState([]);
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [outerColor, setOuterColor] = useState(null);
  //   const [expiry, setExpiry] = useState();

  const [image, setImage] = useState();
  const [smallImage, setSmallImage] = useState();
  const [desc1,setDesc1]=useState()
  const [desc2,setDesc2]=useState()
  const [desc3,setDesc3]=useState()



  //   const [page, setPage] = useState(0);
  //   const [limit, setLimit] = useState(10);
  //   const [isUsed, setIsUsed] = useState(false);
  //   const [isMore, setIsMore] = useState(false);
  //   const [load, setLoad] = useState(false);
  //   const [nodata, setNodata] = useState(false);

  const fetchCouponDetail = () => {
    //console.log("coupondId", couponId)
    axios.get(`/admin/qwik-voucehr/detail/${couponId}`).then((res) => {
      //console.log(res.data.response);
      let data = res.data.response;
      // console.log("res?.data?.response?.images?.mobile-->",res?.data?.response?.images?.mobile)
      setImage(res?.data?.response?.images?.mobile);

      if (res.data.status) {
        setCoupons(res.data.response);
        setPriceArray(res.data.response.price.denominations);
        setPointArray(res?.data?.response?.how_to_use_points||[]);
        setDetailColorArray(res.data.response.detail_colors.length==0?["#000","#000","#000"]:res.data.response.detail_colors);
        // setImage(res?.data?.response?.images?.mobile);
        setSmallImage(res.data.response.images.small);
        setMin(res.data.response.price.min);
        setMax(res.data.response.price.max);
        setOuterColor(res.data.response.outer_color)
        setDesc1(res.data.response.description)
        setDesc2(res.data.response.how_to_use_desc)
        setDesc3(res.data.response.brand_desc)
      
      }
    });
  };

  useEffect(() => {
    
    setTimeout(()=>{
      fetchCouponDetail();

    },500)

    //   return () => {
    //     setCoupons()
    //   }
  }, []);
  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
      // //console.log(img, file);
      width = this.width;
      height = this.height;
      // if (FileSize > 5000) {
      //     return alert(`Image should be to under 50kb reupload image, Your file size is ${FileSize}`)
      // }
      // if (height <= 250 && height > 150 && width <= 1352 && width > 450) {
      //console.log(Dataform);
      axios.post(`/admin/upload-image`, Dataform).then((res) => {
        //console.log(">>Image_url>>", res.data.Image.url);
        let data = res.data.Image.url;

        if (e.target.id == "image") {
          setImage(data);
        } else {
          setSmallImage(data);
        }
        //console.log("image-->", image)
      });
      alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
      // } else {
      //   alert(
      //     `Image height less then 250 & greater then 150 width less then 1352 & greater then 450, Your height=${height} & width=${width}`
      //   );
      // }
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };
  const onChangeHandler = (e) => {
    //console.log("id-->", e.target.id, e.target.value);
    setCoupons({ ...coupons, [e.target.id]: e.target.value });
  };

  const AddPriceInArray = () => {
    let temp = priceArray;
    //console.log("priceinput-->", priceInput);
    temp.push(...priceInput);
    //console.log("temp-->", temp);
    setPriceArray(temp);
    setPriceInput("");
  };

  const AddPointInArray = () => {
    console.log(pointInput,"point")
    console.log(pointArray,"pointArray")
    let temp = pointArray;
    //console.log("priceinput-->", priceInput);
    temp.push(pointInput);
    //console.log("temp-->", temp);
    setPointArray(temp);
    setPointInput("");
  };
  const AddColorInArray = () => {
    let temp = detailColorArray;
    //console.log("priceinput-->", priceInput);
    temp.push(...detailColorInput);
    //console.log("temp-->", temp);
    setDetailColorArray(temp);
    setDetiailColorInput("");
  };

  const handleDeleteRule = (index) => {
    let temp = priceArray;
    temp.splice(index, 1);
    setPriceArray([...temp]);
  };

  const handleDeletePoint = (index) => {
    let temp = pointArray;
    temp.splice(index, 1);
    setPointArray([...temp]);
  };

  const handleColorPoint = (index) => {
    let temp = detailColorArray;
    temp.splice(index, 1);
    setDetailColorArray([...temp]);
  };
  const updateHandler = () => {
    let obj = {...coupons};
    obj.voucherId = couponId;
    obj.name = coupons.name;
    obj.image = image;
    obj.description =desc1;
    obj.how_to_use_desc = desc2;
    obj.brand_desc = desc3;

    //console.log("obj.description-->", obj.description)
    obj.price = priceArray;
    obj.how_to_use_points = pointArray;
    obj.expiry = coupons.expiry;
    obj.small = smallImage;
    obj.outer_color = outerColor;
    obj.detail_colors = detailColorArray;
    obj.c_percentage=coupons.c_percentage
    obj.partner_link=coupons.partner_link
    // obj.partner_link=coupons.partner_link

//     c_percentage
// partner_link

    //console.log("obj-->", obj);
    axios.put(`/admin/qwik-voucehrs`, obj).then((res) => {
      //console.log(res);
      // let data = res.data.response;


      alert(res.data.message);
      if(res.data.status){
        navigate("/qscouponlist");

      }
    });
  };

  const colorHandler = (e) => {
    console.log(e.target.value, "value");
    setOuterColor(e.target.value);
  };

  const closeHandler = () => {
    const colorPicker = document.getElementById("outercolor");

    // Close color picker after selecting a color
    colorPicker.addEventListener("input", () => {
      colorPicker.blur(); // Close the color picker
    });
  };

  const onChangeHandlerColor = (index, newColor) => {
    const updatedColors = [...detailColorArray];
    updatedColors[index] = newColor;
    setDetailColorArray(updatedColors);
    console.log(detailColorArray);
  };

  return (
    <>
      <div style={{ margin: "10px 0px",display:"flex",flexDirection:"column",gap:"20px",background:"#fff",padding:"10px" }}>
        <section
          style={{
            display: "flex",
            alignItems: "space-between",
            justifyContent: "center",
            border: "2px solid gray",
            borderRadius:"12px",
            width: "100%",
            gap: "30px",
            padding: "10px",
            marginTop: "20px",
          }}
        >
          <section
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <section>
              <Typography> Name :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="name"
                value={coupons.name}
                onChange={onChangeHandler}
                // placeholder="Enter App version"
              />
            </section>
            <section style={{ maxWidth: "600px" }}>
              <Typography>Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc1}
                onChange={(e) => {
                  setDesc1( e );
                }}
              />
            </section>

            <section style={{ maxWidth: "600px" }}>
              <Typography>How to use Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc2}
                onChange={(e) => {
                  setDesc2( e );
                }}
              />
            </section>


            <section style={{ maxWidth: "600px" }}>
              <Typography>Brand Description :</Typography>

              <ReactQuill
                theme="snow"
                value={desc3}
                onChange={(e) => {
                  setDesc3(e);
                }}
              />
            </section>

            <section>
              <Typography>Image :</Typography>
              {/* {JSON.stringify(image)} */}
              {image ? (
                <button
                  onClick={() => {
                    setImage("");
                  }}
                >
                  Re-Upload
                </button>
              ) : (
                <TextField
                  type="file"
                  // className="rounded  py-2"
                  id="image"
                  onChange={handlefileInput}
                  placeholder="Select Image"
                  accept="image/*"
                />
              )}
            </section>
            <section>{image && <img src={image} width={"50px"} />}</section>

           

            {/* <section>
              <Typography> Percentage :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="c_percentage"
                value={coupons?.c_percentage}
                onChange={onChangeHandler}
                // placeholder="Enter App version"
              />
            </section>

            <section>
              <Typography> partner_link :</Typography>
              <TextField
                type="link"
                className="rounded  py-2"
                id="partner_link"
                value={coupons?.partner_link}
                onChange={onChangeHandler}
                // placeholder="Enter App version"
              />
            </section> */}

            <section>
              <Typography> Outer Color :</Typography>
              <TextField
                type="color"
                className="rounded  py-2"
                style={{ width: "100px" }}
                id="outercolor"
                value={outerColor}
                onChange={(e) => {
                  colorHandler(e);
                }}
                onClick={closeHandler}
                // placeholder="Enter App version"
              />
            </section>
          </section>
          <section
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <section>
              <Typography> Expiry :</Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="expiry"
                value={coupons.expiry}
                onChange={onChangeHandler}
              />
            </section>
            <section>
              <Typography> Price :</Typography>
              {/* <Typography style={{ color: "red", fontSize: "14px" }}><strong>Note:</strong>`price range must be betweeen ${coupons?.price?.min?coupons?.price?.min:"--"} to ${coupons?.price?.max}`</Typography> */}
              <Typography style={{ color: "red", fontSize: "14px" }}>
                {/* {JSON.stringify(coupons?.price?.min)} */}
                <strong>Note:</strong> Price range must be between {min ?? "--"}{" "}
                to {max ?? "--"}
              </Typography>
              <TextField
                type="text"
                className="rounded  py-2"
                id="price"
                value={priceInput}
                onChange={(e) => {
                  setPriceInput([e.target.value]);
                }}
              />
              <button
                disabled={priceInput ? false : true}
                onClick={AddPriceInArray}
              >
                {priceInput ? "Add Price" : "Enter Price"}
              </button>
            </section>
            <section>
              {priceArray.length > 0 &&
                priceArray.map((item, index) => {
                  return (
                    <Chip
                      key={index}
                      onDelete={() => {
                        handleDeleteRule(index);
                      }}
                      label={item}
                    />
                  );
                })}
            </section>
            <section>
              <Typography> how to use points :</Typography>
              {/* <Typography style={{ color: "red", fontSize: "14px" }}><strong>Note:</strong>`price range must be betweeen ${coupons?.price?.min?coupons?.price?.min:"--"} to ${coupons?.price?.max}`</Typography> */}

              <TextField
                type="text"
                className="rounded  py-2"
                id="points"
                value={pointInput}
                onChange={(e) => {
                  setPointInput(e.target.value);
                }}
              />
              <button
                disabled={pointInput ? false : true}
                onClick={AddPointInArray}
              >
                {pointInput ? "Add Point" : "Enter Point"}
              </button>
            </section>
            {/* {JSON.stringify(pointArray)} */}
            <section>
              {pointArray &&
                pointArray.length > 0 &&
                pointArray.map((item, index) => {
                  return (
                    <Chip
                      key={index}
                      onDelete={() => {
                        handleDeletePoint(index);
                      }}
                      label={item}
                    />
                  );
                })}
            </section>

            <section style={{ display: "flex" }}>
              <Typography> Detail color :</Typography>
             

              {detailColorArray.map((color, index) => (
                <TextField
                  key={index}
                  type="color"
                  className="rounded py-2"
                  id={`detail_color${index}`}
                  value={color}
                  onChange={(e) => onChangeHandlerColor(index, e.target.value)}
                  style={{ width: "100px", margin: "10px" }}
                />
              ))}
            </section>

            <section>
            <Typography> Percentage :</Typography>
            <TextField
              type="text"
              className="rounded  py-2"
              id="c_percentage"
              value={coupons?.c_percentage}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>

          <section>
            <Typography> partner_link :</Typography>
            <TextField
              type="link"
              className="rounded  py-2"
              id="partner_link"
              value={coupons?.partner_link}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>

          <section>
              <Typography>Small Image :</Typography>
              {smallImage ? (
                <button
                  onClick={() => {
                    setSmallImage("");
                  }}
                >
                  Re-Upload
                </button>
              ) : (
                <TextField
                  type="file"
                  // className="rounded  py-2"
                  id="smallimage"
                  onChange={handlefileInput}
                  placeholder="Select Image"
                  accept="image/*"
                />
              )}
            </section>
            <section>
              {smallImage && <img src={smallImage} width={"50px"} />}
            </section>
          </section>
        </section>
        <button
          style={{ padding: "15px 25px", background: "grey", color: "#fff",cursor:"pointer" }}
          onClick={updateHandler}
        >
          Update
        </button>
      </div>
    </>
  );
}

export default Edit;
